"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBarTooltipData = exports.getLineBetweenBarGroupsData = exports.getUniqueGroups = exports.formatTooltipXAxisValue = exports.getSecondaryXAxisTickFormat = exports.getXAxisTickFormat = exports.yAxisTickFormat = void 0;
var tslib_1 = require("tslib");
var d3 = tslib_1.__importStar(require("d3"));
var pipe_1 = tslib_1.__importDefault(require("lodash/fp/pipe"));
var map_1 = tslib_1.__importDefault(require("lodash/fp/map"));
var get_1 = tslib_1.__importDefault(require("lodash/fp/get"));
var sortBy_1 = tslib_1.__importDefault(require("lodash/fp/sortBy"));
var chartUtils_1 = require("../chartUtils");
exports.yAxisTickFormat = function (d) { return chartUtils_1.formatLinearNumbers(d); };
exports.getXAxisTickFormat = function (axisType, width, chartBreakPoints, ticks) {
    switch (axisType) {
        case 'MONTH':
            if (width <= chartBreakPoints.medium[0] && ticks.length > 2) {
                return function (d, i) {
                    return i % 2 === 0 ? chartUtils_1.formatMonths(d, i, ticks, 2) : '';
                };
            }
            return function (d, i) { return chartUtils_1.formatMonths(d, i, ticks, 1); };
        case 'BAND':
            return function (d, i) {
                return d.length > 18 ? d.substring(0, 15) + "..." : d;
            };
        default:
            return function (d) { return d; };
    }
};
exports.getSecondaryXAxisTickFormat = function (axisType, width, chartBreakPoints, ticks) {
    switch (axisType) {
        case 'MONTH':
            if (width <= chartBreakPoints.medium[0] && ticks.length > 2) {
                return function (d, i) {
                    return i % 2 === 0 ? chartUtils_1.formatYears(d, i, ticks, 2) : '';
                };
            }
            return function (d, i) { return chartUtils_1.formatYears(d, i, ticks, 1); };
        default:
            return undefined;
    }
};
exports.formatTooltipXAxisValue = function (axisType, value) {
    switch (axisType) {
        case 'MONTH':
            return d3.timeFormat('%b %Y')(value);
        case 'BAND':
            return value;
        default:
            return chartUtils_1.formatLinearNumbers(value);
    }
};
exports.getUniqueGroups = function (data) {
    return pipe_1.default(get_1.default('groupedData'), sortBy_1.default(get_1.default('group')), map_1.default(get_1.default('group')))(data);
};
exports.getLineBetweenBarGroupsData = function (xScaleGroup, chartHeight, isFirstLine) {
    if (isFirstLine) {
        return [
            {
                x: 0,
                y: 0,
            },
            {
                x: 0,
                y: chartHeight,
            },
        ];
    }
    return [
        {
            x: xScaleGroup.step(),
            y: 0,
        },
        {
            x: xScaleGroup.step(),
            y: chartHeight,
        },
    ];
};
exports.getBarTooltipData = function (subGroups, group) {
    var tooltipData = subGroups.map(function (subgroup) {
        var value = group.values.find(function (v) { return v.subGroupID === subgroup.ID; });
        return tslib_1.__assign(tslib_1.__assign({}, subgroup), { value: value });
    });
    return tooltipData;
};
